import { useEffect, useRef, useState } from 'react';

import { useAppDispatch, useAppSelector } from '@/store/hooks';
import { getActiveChannel } from '@/store/slices/user/selectors';
import { loadProjectsList } from '@/store/slices/projects';

const useFetchProjectsList = () => {
  const activeChannel = useAppSelector(getActiveChannel);

  const [loading, setLoading] = useState(false);

  const fetching = useRef(false);

  const dispatch = useAppDispatch();

  useEffect(() => {
    if (fetching.current || !activeChannel) {
      return;
    }

    fetching.current = true;
    setLoading(true);

    const fetchProjectsList = async () => {
      try {
        await dispatch(loadProjectsList({ channel: activeChannel }));
      } catch (error) {
        console.error('Error fetching projects list:', error);
        fetching.current = false;
      } finally {
        setLoading(false);
      }
    };

    fetchProjectsList();
  }, [activeChannel, dispatch]);

  return { loading };
};

export default useFetchProjectsList;
